import type { MdxBlockReader } from "./registry"
import { calloutsReaders } from "./callouts"
import { colorReaders } from "./color"
import { expandableReaders, fieldsReaders } from "./fields"
import { frameReaders } from "./frame"
import { mermaidReaders } from "./mermaid"
import { promptReaders } from "./prompt"
import { MDX_BLOCK_READERS } from "./registry"
import { accordionReaders, stepsReaders } from "./steps-accordion"
import { tileReaders } from "./tile"
import { treeReaders } from "./tree"
import { updateReaders } from "./update"

// Outer containers first: a reader that ran earlier would lift a block out of
// a later container's body, and the placeholder it leaves would not resolve.
const readers: MdxBlockReader[] = [
	...updateReaders,
	...accordionReaders.filter((reader) => reader.name === "accordion-group"),
	...accordionReaders.filter((reader) => reader.name === "accordion"),
	...stepsReaders,
	...fieldsReaders,
	...expandableReaders,
	...promptReaders,
	...colorReaders,
	...mermaidReaders,
	...tileReaders,
	...treeReaders,
	...frameReaders,
	...calloutsReaders,
]

MDX_BLOCK_READERS.push(...readers)

export { MDX_BLOCK_READERS }
export type { MdxBlockReader }
